import {
  CREATE_IMAGE_FAILURE,
  CREATE_IMAGE_REQUEST,
  GET_ALL_IMAGE_REQUEST,
  GET_ALL_IMAGE_SUCCESS,
  GET_ALL_IMAGE_FAILURE,
  DELETE_IMAGE_REQUEST,
  DELETE_IMAGE_FAILURE,
  UPDATE_IMAGE_REQUEST,
  UPDATE_IMAGE_FAILURE,
  CREATE_IMAGE_SUCCESS,
  DELETE_IMAGE_SUCCESS,
  UPDATE_IMAGE_SUCCESS,
} from "./ActionType";

const initialState = {
  images: [],
  image: null,
  loading: false,
  error: "",
};

export const vendorProductImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_IMAGE_REQUEST:
      return { ...state, loading: true };

    case CREATE_IMAGE_SUCCESS:
      return { ...state, loading: false, error: "", image: action.payload };

    case CREATE_IMAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_IMAGE_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_IMAGE_SUCCESS:
      return { ...state, loading: false, error: "", images: action.payload };

    case GET_ALL_IMAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_IMAGE_REQUEST:
      return { ...state, loading: true };

    case DELETE_IMAGE_SUCCESS:
      return { ...state, loading: false, error: "", image: action.payload };

    case DELETE_IMAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_IMAGE_REQUEST:
      return { ...state, loading: true };

    case UPDATE_IMAGE_SUCCESS:
      return { ...state, loading: false, error: "", image: action.payload };

    case UPDATE_IMAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
